/* eslint-disable react/no-danger */
import React, { useCallback, useContext } from 'react';
import _ from 'underscore';
import $ from 'jquery';
import classNames from 'classnames';
import { I18nContext } from '@bingads-webui-react/i18n-context';
import { useDefaultStyles } from '@bingads-webui-react/with-default-styles';
import { Button } from '@fluentui/react-components';
import { ServerContext } from '@bingads-webui-campaign-react/server-context';
import {
  Call20Regular,
  ChatEmpty20Regular,
  QuestionCircle20Regular,
  PersonSupport20Regular,
} from '@fluentui/react-icons';
import { ICustomSupportOptions } from '@bingads-webui-campaign-react/sdk-utils';

declare global {
  // eslint-disable-next-line no-unused-vars
  interface Window { apex_glb: any }
}

const getStyles = () => ({
  sdkBottomBar: {
  },
  supportOptionsLine: {
    display: 'flex',
    alignItems: 'center',
    padding: '0 43px',
    '&:last-child': {
      marginBottom: 24,
    },
  },
  description: {
    fontSize: 12,
    color: '#616161',
  },
  buttonSplit: {
    height: 20,
    borderRight: '1px solid #f2f2f2',
  },
});

export const SDKBottomBar: React.FC<{}> = React.memo(() => {
  const classes = useDefaultStyles(getStyles);
  const i18n = useContext(I18nContext) as any;
  const serverContext = useContext(ServerContext);
  const isCallAvailable = !!_.get(serverContext, ['SupportOptions', 'RequestCallText']);
  const isChatAvailable = !!_.get(serverContext, ['SupportOptions', 'IfShowLiveChat']);
  const customSupportOptions: ICustomSupportOptions = _.get(serverContext, ['SupportOptions', 'customSupportOptions']);

  const onRequestCallClick = useCallback(() => {
    $('#requestCallTrigger').trigger('click');
  }, []);
  const onSupportChatClick = useCallback(() => {
    $('#msSupportChatTrigger').trigger('click');
  }, []);
  const onBrowserHelpArticleClick = useCallback(() => {
    window.open(`${window.apex_glb.EndPoint}/#apex/ads/${window.apex_glb.Language}/60203/-1`);
  }, []);

  return (
    <div className={classNames(classes.sdkBottomBar, 'sdk-bottom-bar')}>
      <div className={classNames(classes.supportOptionsLine, 'built-in-options')}>
        {(isCallAvailable || isChatAvailable) &&
          <span
            className={classes.description}
            dangerouslySetInnerHTML={{
              __html: i18n.getString(_TL_('Request help from {{maBrand}} through the following options:'))
                .replace('{{maBrand}}', `<b>${i18n.getString(_TL_('Microsoft Advertising'))}</b>`),
            }}
          />}
        {isCallAvailable && (
          <Button appearance="transparent" icon={<Call20Regular />} onClick={onRequestCallClick}>
            {i18n.getString(_TL_('Request call from a Support agent'))}
          </Button>)}
        <div className={classes.buttonSplit} />
        {isChatAvailable && (
          <Button appearance="transparent" icon={<ChatEmpty20Regular />} onClick={onSupportChatClick}>
            {i18n.getString(_TL_('Start a live chat'))}
          </Button>)}
        {(isCallAvailable || isChatAvailable) && <div className={classes.buttonSplit} />}
        <Button appearance="transparent" onClick={onBrowserHelpArticleClick} icon={<QuestionCircle20Regular />}>
          {i18n.getString(_TL_('Browse a help article'))}
        </Button>
      </div>
      {customSupportOptions && (
        <div className={classNames(classes.supportOptionsLine, 'external-options')}>
          <span
            className={classes.description}
            dangerouslySetInnerHTML={{
              __html: i18n.getString(_TL_('Request help from {{supportTextPlaceholder}}:'))
                .replace('{{supportTextPlaceholder}}', `<b>${customSupportOptions.headerText}</b>`),
            }}
          />
          {customSupportOptions.supportOptions.map((option) => {
            const optionText = option.text || i18n.getString(_TL_('Contact support'));
            return (
              <Button key={optionText} appearance="transparent" onClick={option.onClick} icon={<PersonSupport20Regular />}>
                {optionText}
              </Button>
            );
          })}
        </div>)}
    </div>
  );
});
